import React from "react";
import { PageHero, PageBody, formatDate } from "./_shared";
import { useFood } from "./FoodLayout";
import { FileText, ExternalLink } from "lucide-react";

export default function Notices() {
  const data = useFood();
  const notices = data.notices_general || [];
  return (
    <div data-testid="ft-notices">
      <PageHero eyebrow="Official Notices" title="What's happening on campus" />
      <PageBody>
        {notices.length === 0 ? (
          <div className="bg-white rounded-lg p-12 text-center text-sm text-[#4D5A52] ring-1 ring-[#E6E2D6]">No notices have been posted yet.</div>
        ) : (
          <div className="space-y-3">
            {notices.map((n) => (
              <a key={n.id} href={n.file_url || n.external_url || "#"} target="_blank" rel="noopener noreferrer"
                 className="block bg-white rounded-md p-5 ring-1 ring-[#E6E2D6] hover:ring-[#1F6B3F] transition-colors">
                <div className="flex items-start gap-3">
                  <FileText className="text-[#1F6B3F] mt-0.5" size={20} />
                  <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-wider text-[#F4751F] font-semibold">{formatDate(n.posted_on || n.notice_date)}</div>
                    <div className="text-sm mt-1 text-[#0F1F17] font-medium">{n.title}</div>
                    {n.body && <p className="text-[12px] text-[#4D5A52] mt-1 leading-relaxed">{n.body}</p>}
                  </div>
                  <ExternalLink className="text-[#4D5A52]" size={14} />
                </div>
              </a>
            ))}
          </div>
        )}
      </PageBody>
    </div>
  );
}
